// 此处用于存放所有登录相关的接口请求
import axios from 'axios'
import request from '@/utils/request'

// /////////////////////////////  登录、注册、密码  //////////////////////////////////

// 发送验证码
export const sendVerificationCodeApi = (userData) => {
  return request.post('/api/send_verification_code', userData)
}

// 注册
export const registerUser = (userData) => {
  return request.post('/api/register', userData)
}

// 手机验证码登录
export const smsLogin = (userData) => {
  return request.post('/api/sms_login', userData)
}

// 密码登录
export const passwordLogin = (userData) => {
  return request.post('/api/login', userData)
}

// 忘记密码
export const forgotPassword = (userData) => {
  return request.post('/api/forgot_password', userData)
}

// 保存用户头像图片
export const saveAvatarUrl = (formData) => {
  return request.post('/api/save_avatar_url', formData)
}

// 封装检查认证的函数
export const checkAuth = (token) => {
  return request.post('/api/check_auth', token)
}

// 获取用户信息，包括头像URL和账户余额
export const getUserInfo = () => {
  return request.get('/api/get_user_info')
}

// /////////////////////////////  七牛云令牌、文件上传  //////////////////////////////////

// 获取上传文件的token,通过在前端将令牌添加到请求头中，然后在后端解析令牌来获取用户的手机号。
export const getUpQiniuToken = () => {
  return request.post('/api/get_upload_token')
}

// 将文件上传到七牛云存储空间中   单独ip
export const uploadToQiniu = (file, fileName, qiniuUploadToken) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('key', fileName)
  formData.append('token', qiniuUploadToken)
  const QINIU_UPLOAD_URL = 'https://up-z2.qiniup.com'// 不同区域不同地址

  return axios.post(QINIU_UPLOAD_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// /////////////////////////////  音频  //////////////////////////////////

// 音频处理
export const saveAudioAdjustFileUrl = (formData) => {
  return request.post('/api/save_audio_url', formData)
}

// 生成字幕
export const genSubtitle = (formData) => {
  return request.post('/api/audioSubtitle', formData)
}

// 人声分离
export const voiceSeparation = (formData) => {
  return request.post('/api/audioVoiceSeparation', formData)
}

// 视频处理
export const savevidioAdjustFileUrl = (formData) => {
  return request.post('/api/save_video_url', formData)
}

export const saveMergeVideosFileUrl = (formData) => {
  return request.post('/api/save_mergeVideos_url', formData)
}

// 图片处理
export const saveImageFileUrl = (formData) => {
  return request.post('/api/save_image_url', formData)
}

// 视频翻译处理
// 一键翻译
export const saveoneclickVideoTranslateFileUrl = (formData) => {
  return request.post('/api/save_oneclick_video_translation_url', formData)
}

// 获取用户操作记录
export const getUserRecords = (requestData) => {
  // return 'wwwww'
  return request.post('/api/user-records', requestData)
}

// 获取用户操作记录
export const getRechargeRecords = (requestData) => {
  // return 'wwwww'
  return request.post('/api/user-recharge-records', requestData)
}

export const getAccountBalance = (requestData) => {
  // return 'wwwww'
  return request.post('/api/get-account-balance', requestData)
}

export const updateAccountBalance = (requestData) => {
  // return 'wwwww'
  return request.post('/api/update-account-balance', requestData)
}

// 获取服务器状态列表
export const getServersStatus = () => {
  return request.post('/api/get-servers-status')
}

// 删除服务器记录
export const deleteServer = (requestData) => {
  return request.post('/api/delete-server', requestData)
}

// 【新增】数据备份与恢复接口
export const saveTableData = (data) => {
  return request.post('/api/save-table-data', data)
}

export const restoreTableData = (data) => {
  return request.post('/api/restore-table-data', data)
}

export const getBackupList = () => {
  return request.get('/api/backup-list')
}

// 【新增】清除七牛云过期文件接口
export const cleanupExpiredRecords = () => {
  return request.post('/api/cleanup-expired-records')
}

// 【新增】管理员退款接口
// * @param {Object} data - { user_phone, alipay_order_id, refund_amount, refund_reason }
// * @returns {Promise}
export const adminRefund = (data) => {
  return request.post('/api/admin/refund', data)
}

// * 【新增】查询订单退款信息（用于显示可退金额）
// * @param {Object} params - { phone, alipay_order_id }
// * @returns {Promise}
export const queryOrderInfo = (params) => {
  return request.get('/api/admin/order-refund-info', { params })
}

// * 【新增】查询退款记录列表（分页+筛选）
// * @param {Object} params - { phone, status, page, page_size }
// * @returns {Promise}
export const getRefundRecords = (params) => {
  return request.get('/api/admin/refund-records', { params })
}

export const queryUsersTable = (params) => {
  return request.get('/api/query-users', { params })
}

// 删除用户记录
export const deleteUserRecord = (recordId) => {
  // return 'wwwww'
  return request.post('/api/delete-records', recordId)
}

export const getPendingTasks = () => {
  // return 'wwwww'
  return request.post('/api/get-pending-tasks')
}

// 网页后端，查询用户操作记录
export const videosDownapi = (requestData) => {
  return request.post('/api/videosDown', requestData)
}
